import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Footer, Typography, Link } from '@sgi/gravity';
import useMailTo from '../../../../../shared/utils/mailTo';
import { Flex, useMultiStyleConfig } from '@chakra-ui/react';
import './Footer.css';
const feedbackQuestions = [
    'What was your initial impression of the flow?',
    'Did you find the registration process easy to follow?',
    'Were the options presented to you clear and straightforward?',
    'Was the language used easy to understand?',
    'Was the flow user-friendly?',
    'Did you experience any difficulties or challenges while using the flow?',
    'What did you like best about the flow?',
    'What could be improved in the flow?',
];
const BuildBodyMessage = (questions) => {
    let message = '\n ';
    questions?.forEach(question => {
        message += ` - ${question} \n `;
    });
    return message;
};
const Separator = () => {
    return (_jsx(Typography, { display: { base: 'none', md: 'inline' }, color: "gray.700", children: "|" }));
};
const FooterDefaultContent = () => {
    const styles = useMultiStyleConfig('Footer');
    return (_jsxs(Flex, { sx: styles.defaultContent, children: [_jsx(Link, { href: "https://www.sgi.sk.ca", isExternal: true, children: "sgi.sk.ca" }), _jsx(Separator, {}), _jsx(Link, { href: "https://www.sgicanada.ca", isExternal: true, children: "sgicanada.ca" }), _jsx(Separator, {}), _jsx(Link, { href: "https://www.sgi.sk.ca/salvage", isExternal: true, children: "sgi salvage" }), _jsx(Separator, {}), _jsx(Link, { href: "https://www.sgi.sk.ca/terms", isExternal: true, children: "Terms of use" }), _jsx(Separator, {}), _jsx(Link, { href: "https://www.sgi.sk.ca/privacy", isExternal: true, children: "Privacy statement" }), _jsx(Separator, {}), _jsx(Link, { onClick: () => {
                    document.getElementById('nebula_div_btn').click();
                }, className: "feedback-button", children: "Feedback" }), _jsxs(Typography, { children: ["\u00A9 SGI ", new Date().getFullYear()] })] }));
};
export function AppFooter() {
    const mailTo = useMailTo();
    return (_jsx(Footer, { "data-testid": "business-footer-testid", onCommentClick: () => mailTo('DRIVEFeedbackIssuerVehicleRegistration@sgi.sk.ca', 'Feedback', BuildBodyMessage(feedbackQuestions)), children: _jsx(FooterDefaultContent, {}) }));
}
